import { useMemo } from "react"

import { useFetchTeams } from "@/hooks/api/teams/queries"
import { useFetchUsers } from "@/hooks/api/users"
import { MentionOption } from "@/components/lexical/plugins/mention-dropdown/types"

export function useNoteTeamMentionables(bookId: string | undefined) {
  const { data: teamsData } = useFetchTeams({ enabled: !!bookId, bookIdOverride: bookId })
  const { data: usersData } = useFetchUsers(bookId)

  return useMemo(() => {
    if (!bookId) return []

    const bookUserIds = new Set(usersData?.users.map((user) => user.id))
    return (teamsData?.teams ?? [])
      .filter((team) => team.users.some((user) => bookUserIds.has(user.id)))
      .map((team) => new MentionOption({ type: "team", id: team.id, display_label: team.name }))
  }, [bookId, teamsData, usersData])
}
